// Lib
import { Action, handleActions } from 'redux-actions';

// Actions
import { SetPost } from '@actions/posts';
import {
  UpdateUserTheme,
  UserAdd,
  UserDataLoaded,
  UserUpdate,
} from '@actions/user';

interface BackgroundSettings {
  [key: string]: unknown;
}

interface User {
  username: string;
  backgroundSettings?: BackgroundSettings;
  [key: string]: unknown;
}

interface UsersState {
  [username: string]: User;
}

interface UserDataLoadedPayload {
  users?: UsersState;
  [key: string]: unknown;
}

interface UpdateUserThemePayload {
  username: string;
  backgroundSettings: BackgroundSettings;
}

interface SetPostPayload {
  users?: UsersState;
  [key: string]: unknown;
}

type UserDataLoadedAction = Action<UserDataLoadedPayload>;
type UserAddAction = Action<User>;
type UserUpdateAction = Action<User>;
type UpdateUserThemeAction = Action<UpdateUserThemePayload>;
type SetPostAction = Action<SetPostPayload>;

const initialState: UsersState = {};

export default handleActions<
  UsersState,
  UserDataLoadedPayload | User | UpdateUserThemePayload | SetPostPayload
>(
  {
    [UserDataLoaded.toString()]: (
      state: UsersState,
      { payload }: UserDataLoadedAction,
    ): UsersState => ({ ...state, ...payload.users }),
    [UserAdd.toString()]: (
      state: UsersState,
      { payload }: UserAddAction,
    ): UsersState => ({
      ...state,
      [payload.username]: { ...state[payload.username], ...payload },
    }),
    [UserUpdate.toString()]: (
      state: UsersState,
      { payload }: UserUpdateAction,
    ): UsersState => ({
      ...state,
      [payload.username]: { ...state[payload.username], ...payload },
    }),
    [UpdateUserTheme.toString()]: (
      state: UsersState,
      { payload }: UpdateUserThemeAction,
    ): UsersState => ({
      ...state,
      [payload.username]: {
        ...state[payload.username],
        backgroundSettings: {
          ...state[payload.username]?.backgroundSettings,
          ...payload.backgroundSettings,
        },
      },
    }),
    [SetPost.toString()]: (
      state: UsersState,
      { payload }: SetPostAction,
    ): UsersState => ({ ...state, ...payload.users }),
  },
  initialState,
);
